import React, { useEffect } from 'react';

import { RouteProp, useIsFocused, useRoute } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';

import { Screen } from '@/components/ScreenComponent';
import { CxtType, addCxtTag, removeCxtTag } from '@/feature/analytics/connextraTag';
import { LobbyList } from '@/feature/lobby/components/LobbyList';
import { useActiveProductConfig } from '@/hooks/use-active-product';
import { useOneTrust } from '@/hooks/use-one-trust';
import { ROOT_NAVIGATOR_ID } from '@/navigation/container';
import { PickemLobbyStackParamList } from '@/navigation/pickem/types';

import { PlayerFiltersProvider } from '../hooks/use-player-filters';

export type LobbyStackScreenProp = StackNavigationProp<
    PickemLobbyStackParamList,
    'LobbyScreen',
    typeof ROOT_NAVIGATOR_ID
>;

export const LobbyScreen = () => {
    const route = useRoute<RouteProp<any, 'LobbyScreen'>>();
    const { league } = route.params || {};
    const productConfig = useActiveProductConfig();
    const isFocused = useIsFocused();

    const { enabled: isMaintenanceEnabled } = productConfig?.appMaintenanceConfig?.primary || {};

    useOneTrust();

    useEffect(() => {
        if (isFocused) {
            addCxtTag({ pageType: CxtType.HOMEPAGE });
        } else {
            removeCxtTag();
        }
    }, [isFocused]);

    return !isMaintenanceEnabled ? (
        <Screen>
            <PlayerFiltersProvider>
                <LobbyList league={league} />
            </PlayerFiltersProvider>
        </Screen>
    ) : null;
};
